import "./NotFound.css" // Import the CSS file for styling

const NotFound = () => {
    return (
        <div className="not-found-container">
            <h1>404 - Not Found</h1>
            <p>Oops! The page you are looking for does not exist or you are not authorized to access.</p>
        </div>
    )
}

export default NotFound
